module.exports = __webpack_public_path__ + "img/water4.4ce0be8f.png";